import { render, staticRenderFns } from "./CategoryKey.vue?vue&type=template&id=222a21fa"
import script from "./CategoryKey.vue?vue&type=script&lang=js"
export * from "./CategoryKey.vue?vue&type=script&lang=js"
import style0 from "./CategoryKey.vue?vue&type=style&index=0&id=222a21fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports